import { createAuthClient } from "better-auth/react";

/**
 * Same-origin: in production one Worker serves the API and this SPA, and in dev
 * Vite proxies /api to it. So no baseURL is needed, and the session cookie
 * stays first-party — no CORS, no third-party cookie problems.
 */
export const authClient = createAuthClient({ basePath: "/api/auth" });

export const { signIn, signUp, signOut, useSession, resetPassword } = authClient;

/**
 * Request a reset link.
 *
 * Called through `$fetch` rather than a named client method because this build
 * types the method inconsistently. The path is `/request-password-reset` —
 * `/forget-password` is the older name and 404s here, which is worth stating
 * because both appear in Better Auth's own documentation.
 *
 * The response is deliberately the same whether or not the address exists, so
 * this cannot be used to find out who has an account.
 */
export async function forgetPassword(body: { email: string; redirectTo: string }) {
  return authClient.$fetch("/request-password-reset", { method: "POST", body });
}

/** Better Auth error shapes vary by cause; this is the readable bit. */
export function authErrorMessage(err: unknown): string {
  if (typeof err === "object" && err !== null) {
    const e = err as { message?: string; error?: { message?: string } };
    return e.error?.message ?? e.message ?? "Something went wrong. Try again.";
  }
  return "Something went wrong. Try again.";
}
